<!-- 车辆通行记录页面 -->
<template>
  <div class="access-record-container ">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <!-- 表格按钮 自定义 -->
            <template slot="search_passageTime">
              <div>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择开始时间"
                  v-model="searchParams.startTime"
                  default-time="00:00:00"
                  style="width: 182px"
                ></el-date-picker>
                <span style="padding: 0 5px">至</span>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择结束时间"
                  v-model="searchParams.endTime"
                  default-time="23:59:59"
                  style="width: 182px"
                ></el-date-picker>
              </div>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <!-- <template slot="trafficFileCode" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.trafficFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.trafficFileCode), $event)
                "
              />
            </template> -->
            <!-- 车牌号点击可以跳转详情页面 -->
            <template slot="plateCode" slot-scope="scope">
              <span
                style="cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.plateCode }}</span
              >
            </template>
            <!-- 查看详情表单 自定义 -->
            <!-- <template slot="trafficFileCodeView" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.trafficFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.trafficFileCode), $event)
                "
              />
            </template> -->
          </ioc-table>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="通行记录详情"
    >
      <div class="panel-content">
        <div class="content-top">
          <div class="detail-info">
            <div class="info-item">
              <span class="label">车辆号牌：</span>
              <span class="item-value">{{ form.plateCode }}</span>
            </div>
            <!-- <div class="info-item">
                  <span class="label">性别</span>
                  <span class="item-value">{{ detailForm.personnelType }}</span>
                </div> -->
            <div class="info-item">
              <span class="label">通道名称：</span>
              <span class="item-value">{{ form.deviceName }}</span>
            </div>
            <div class="info-item">
              <span class="label">出入类型：</span>
              <span class="item-value">{{
                form.trafficType == 1 ? "入场" : "出场"
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">通行时间：</span>
              <span class="item-value">{{ form.trafficTime }}</span>
            </div>
            <div class="info-item">
              <span class="label">车辆图片：</span>
              <span class="item-value">
                <img
                  style="width: 176px; height: 176px;cursor: pointer;position:absolute"
                  onerror="this.src='/images/theme/newDark/default.png'"
                  :src="getImgPath(form.trafficFileCode)"
                  @click="showViewer(getImgPath(form.trafficFileCode), $event)"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>
  </div>
</template>
<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/table";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      form: {},
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut:null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
    };
  },
  beforeDestroy() {
    this.getTimeOut && clearTimeout(this.getTimeOut);
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    handSetTime() {
      if (this.getTimeOut) {
        clearTimeout(this.getTimeOut);
      }
      this.getTimeOut = setTimeout(() => {
        this.getList();
      }, 1000 * 60 * 2);
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url,e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // TODO获取列表
    getList() {
      const params = {};
      params.plateCode = this.searchParams.plateCode;
      params.deviceName = this.searchParams.deviceName;
      params.trafficType = this.searchParams.trafficType;
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      params.beginTime = this.searchParams.startTime
        ? Dates.format(this.searchParams.startTime)
        : "";
      params.endTime = this.searchParams.endTime
        ? Dates.format(this.searchParams.endTime)
        : "";

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.vehicle.getRecordList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.handSetTime()
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },

    handleView(row, index) {
      this.showPanel = true;
      this.form = row;
      // console.log(row.trafficFileCode);
      // if (row.trafficFileCode) {
      //   this.form.trafficFileCode =
      //     "/common/file/downLoadFileStream.json?fileCode=" +
      //     row.trafficFileCode;
      // }
      // console.log("...detail", this.showPanel);
      //  this.$refs.accessTab.rowView(row, index);
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      this.searchParams = param;
      // let tempObj = {};
      // tempObj.startTime = this.searchParams.startTime;
      // tempObj.endTime = this.searchParams.endTime;

      // this.searchParams = Object.assign(param);
      // console.log(this.searchParams, "===query");
      if (param.passageTime && param.passageTime.length > 0) {
        this.searchParams.startTime = param.passageTime[0];
        this.searchParams.endTime = param.passageTime[1];
      }
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.searchParams.startTime = "";
      this.searchParams.endTime = "";
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}
</style>
